/**
 * Copyright 2026 Perform Content Services Limited. Confidential and Proprietary. All Rights Reserved.
 */
import {Reducer} from 'redux';

import {
  CONCURRENTS_FETCHING,
  CONCURRENTS_FETCHING_DONE,
  CONCURRENTS_FETCHING_ERROR,
  SET_CONCURRENTS,
  SET_CONCURRENTS_DONE,
  SET_CONCURRENTS_ERROR,
  CONCURRENTS_SET_CSV,
  CONCURRENTS_SET_QUERY,
  ConcurrentsActions
} from 'store/action/concurrents';
import {ILineChartData} from 'interfaces/chartProps';
import {IPortalError} from 'utility/error-handler';

export interface IConcurrentsState {
  concurrents: ILineChartData[];
  isFetching: boolean;
  error: null | Error | IPortalError;
  csv: string;
  queryData: {start: Date; end: Date}[];
}

const initialState: IConcurrentsState = {
  concurrents: [],
  isFetching: false,
  error: null,
  csv: '',
  queryData: []
};
const concurrents: Reducer<Readonly<IConcurrentsState>, ConcurrentsActions> = (
  state: IConcurrentsState = initialState,
  action: ConcurrentsActions
) => {
  switch (action.type) {
    case CONCURRENTS_FETCHING:
    case SET_CONCURRENTS: {
      return {
        ...state,
        isFetching: true
      };
    }

    case CONCURRENTS_FETCHING_DONE:
    case SET_CONCURRENTS_DONE: {
      return {
        ...state,
        isFetching: false,
        concurrents: [...action.payload, ...state.concurrents],
        error: null
      };
    }

    case CONCURRENTS_FETCHING_ERROR: {
      return {
        ...state,
        isFetching: false,
        error: action.error
      };
    }

    case SET_CONCURRENTS_ERROR: {
      return {
        ...state,
        isFetching: false,
        error: action.error
      };
    }

    case CONCURRENTS_SET_CSV: {
      return {
        ...state,
        csv: action.payload
      };
    }

    case CONCURRENTS_SET_QUERY: {
      return {
        ...state,
        queryData: [...state.queryData, action.payload],
        isFetching: false
      };
    }

    default: return state;
  }
};

export default concurrents;